getSolutionsInfohubSliders = () => {
    if ( solutions_infohub_info ) {
        return solutions_infohub_info.sliders;
    }
    return [];
}
